<template>
    <div class="ship-card-main-style">
        <el-row class="ship-card-btn">
            <booking-history-filter/>
        </el-row>
        <el-card >
            <el-row>
                <booking-history-table/>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import BookingHistoryTable from '@/components/Booking/BookingHistoryTable.vue'
import BookingHistoryFilter from '@/components/Booking/BookingHistoryFilter.vue'

export default {
    name: 'ShipFlowBase',
    components: {
        BookingHistoryTable,
        BookingHistoryFilter
    }
}
</script>

<style lang="scss" scoped>
    .ship-card-main-style{
        margin: 10px 10%;
        .ship-crad-style{
            padding: 40px;
        }
    }

    .ship-card-btn{
        padding-bottom: 25px;
    }
</style>
